import type { CodeProduitLocal } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getCodesProduitsLocaux = (params: URLSearchParams) => request.get<unknown, TemplateRequestGet<CodeProduitLocal>>(
  `/api/finances/comptabilite/parametrescomptabilites/codeProduitLocal?${params.toString()}`,
);

export default getCodesProduitsLocaux;
